import { Injectable } from '@angular/core';
import { NabiralnikService } from 'arsktrp-shared-components';
import Keycloak from 'keycloak-js';

@Injectable({
  providedIn: 'root',
})
export class NabiralnikEvtService extends NabiralnikService {
  public override connectParameters(): {
    serviceUrl?: string;
    protocols?: string | string[];
    keycloak: Keycloak;
    serverPingTimeout: number;
  } {
    return {
      serviceUrl: '/notification/websocket/globalEndpoint/EVT',
      protocols: [],
      keycloak: this._keycloak,
      serverPingTimeout: 15 * 60 * 1000,
    };
  }
}
